export default function ErroCarregamento({ mensagem, onRetry }) {
  return (
    <div className="empty-state">
      <i className="bi bi-exclamation-octagon" />
      <div style={{ color: 'var(--wh-ink)', fontWeight: 600, marginBottom: 4 }}>
        {mensagem || 'Não foi possível carregar os dados.'}
      </div>
      <div style={{ fontSize: 13, marginBottom: 16 }}>Verifique sua conexão e tente novamente.</div>
      {onRetry && (
        <button type="button" className="wh-btn wh-btn-outline" onClick={onRetry}>
          <i className="bi bi-arrow-clockwise" /> Tentar novamente
        </button>
      )}
    </div>
  );
}

export function extrairMensagemErro(err, fallback = 'Não foi possível carregar os dados.') {
  const detalhe = err?.response?.data?.detail;
  if (typeof detalhe === 'string') return detalhe;
  if (Array.isArray(detalhe)) return detalhe.map((d) => d.msg).join(' · ');
  return fallback;
}
